import React, {useEffect} from "react";
import {
  ModalBackButton,
  ModalContainer,
  ModalText,
} from "../../common/components/modules/modal/modalComponents";
import {PrimaryLoadingButton} from "../../common/components/elements/button/PrimaryButton";
import {FormContainer, FormText} from "../../common/components/collections/form/forms";
import styled from "styled-components";
import Modal from "../../common/components/modules/modal/Modal";
import useRouter from "../../common/hooks/useRouter";
import routes from "../../common/routes";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import * as Notifications from "src/core/notifications";
import Title from "src/core/common/components/modules/Title";

function DeactivateAccountModal({isOpen, closeModal = () => {}}) {
  const router = useRouter();
  const [authState, authApi] = useAuthentication();

  function deactivateAccount() {
    authApi.deactivateUser();
  }

  function goBack() {
    router.safeBack();
  }

  useEffect(() => {
    if (authState && authState.data === null) {
      Notifications.success("Account deactivated successfully.");
      router.push(routes.home);
    }
  }, [authState, router]);

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <ModalBackButton onClick={() => router.safeBack()} />
      <ModalContainer>
        <Title>Deactivate account</Title>
        <CenterModalText>
          Are you sure you want to deactivate your online account?
        </CenterModalText>
        <FormContainer>
          <PrimaryLoadingButton onClick={goBack} label="Not yet" />
          <Footer alignment={"center"}>
            <span onClick={deactivateAccount}>Yes.</span>
          </Footer>
        </FormContainer>
      </ModalContainer>
    </Modal>
  );
}

const CenterModalText = styled(ModalText)`
  text-align: center;
  margin-bottom: 50px;
`;

const Footer = styled(FormText)`
  margin-top: ${({theme}) => theme.v2.spacing(6)};

  > span:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export default DeactivateAccountModal;
